/* Redirige le paiement du thème (page panier, tiroir panier, bouton « Commander ») vers checkout.noria-paris.com.
   À déposer dans assets/noria-checkout.js et à charger dans layout/theme.liquid :
   <script src="{{ 'noria-checkout.js' | asset_url }}" defer></script>  */
(function () {
  var CHECKOUT = 'https://checkout.noria-paris.com/';
  var going = false;

  function b64url(s) {
    return btoa(unescape(encodeURIComponent(s))).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
  }

  function go(ev) {
    if (ev) { ev.preventDefault(); ev.stopImmediatePropagation(); }
    if (going) return;
    going = true;
    fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = (cart.items || []).map(function (i) { return { v: i.variant_id, q: i.quantity }; });
        if (!items.length) { going = false; return; }
        var url = CHECKOUT + '?c=' + b64url(JSON.stringify(items));
        var fbclid = new URLSearchParams(location.search).get('fbclid');
        if (fbclid) url += '&fbclid=' + encodeURIComponent(fbclid);
        location.href = url;
      })
      .catch(function () { going = false; });
  }

  function isCheckoutTrigger(el) {
    if (!el || !el.closest) return null;
    return el.closest('button[name="checkout"], input[name="checkout"], a[href^="/checkout"], a[href*="/checkouts/"], [data-checkout-button], .cart__checkout-button');
  }

  document.addEventListener('click', function (e) {
    if (isCheckoutTrigger(e.target)) go(e);
  }, true);

  document.addEventListener('submit', function (e) {
    var f = e.target;
    var action = (f.getAttribute('action') || '').toLowerCase();
    var sub = e.submitter;
    if (action.indexOf('/checkout') === 0 || (sub && sub.name === 'checkout')) go(e);
  }, true);
})();
